import clsx from "clsx";

import AudioIcon from "./assets/audio.component.svg";
import ChevronDownIcon from "./assets/chevron-down.component.svg";
import CloseIcon from "./assets/close.component.svg";
import ClockIcon from "./assets/clock.component.svg";
import ForwardIcon from "./assets/forward.component.svg";
import GlobeIcon from "./assets/globe.component.svg";
import HeadphonesIcon from "./assets/headphones.component.svg";
import HeadphonesActiveIcon from "./assets/headphones-active.component.svg";
import HomeIcon from "./assets/home.component.svg";
import HomeInactiveIcon from "./assets/home-inactive.component.svg";
import NextIcon from "./assets/next.component.svg";
import PauseIcon from "./assets/pause.component.svg";
import PlayIcon from "./assets/play.component.svg";
import PreviousIcon from "./assets/previous.component.svg";
import RewindIcon from "./assets/rewind.component.svg";

import * as styles  from "./styles.module.scss";

const DEFAULT_SIZE = 24;

export const Icon = ({ name, size, width, height, withInlineStyle = true, additionalClasses = '' }) => {
    if (name === null || name === undefined) {
        return null;
    }

    const IconImage = resolveImage(name);

    const style = withInlineStyle ? {
        '--icon-width': `${width ?? size ?? DEFAULT_SIZE}px`,
        '--icon-height': `${height ?? size ?? DEFAULT_SIZE}px`,
    } : null;

    return IconImage ? (
        <div className={clsx(styles.icon, additionalClasses)} style={style}>
            <IconImage />
        </div>
    ) : null;
};

const resolveImage = (name) => {
    switch (name) {
        case "audio":
            return AudioIcon;
        case "chevron-down":
            return ChevronDownIcon;
        case "close":
            return CloseIcon;
        case "clock":
            return ClockIcon;
        case "forward":
            return ForwardIcon;
        case "globe":
            return GlobeIcon;
        case "headphones":
            return HeadphonesIcon;
        case "headphones-active":
            return HeadphonesActiveIcon;
        case "home":
            return HomeIcon;
        case "home-inactive":
            return HomeInactiveIcon;
        case "next":
            return NextIcon;
        case "pause":
            return PauseIcon;
        case "play":
            return PlayIcon;
        case "previous":
            return PreviousIcon;
        case "rewind":
            return RewindIcon;
        default:
            return null;
    }
};
